export const CHAT_DIALOG_MESSAGE_PROP_PATH = 'chatDialogMessage';
